import slice from './slice';

export const {
    addStructure, changeProteinFamily,
    changeTarget, removeStructure,
    setCompoundTableState, setScoringTableState,
    setJobsCompoundsTableState,
    setSidePanelWidth,
    removeAllStructures, reset,
    setCoralMapState, setTableState,
    setProteinTarget,
    setAllTargetInfo, setActiveChart,
    setTargetsTableState,
    setScreeningTableState,
    setJobsGridTableState,
    updateScreeningPropertySettings,
} = slice.actions;

export default slice.reducer;
